var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
    'btn_delete': _vm.type == 'delete',
    'btn_blue': _vm.type == 'blue',
    'btn_yellow': _vm.type == 'yellow',
    'btn_disabled': _vm.type == 'disabled',
    'unselected': _vm.type == 'unselected'
  },style:({ maxWidth: _vm.maxWidth + 'px' }),attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v("\n  "+_vm._s(_vm.btnText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323c4134","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseBtn.vue
// module id = null
// module chunks = 